import * as React from 'react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import '../../../hmilib/hmiglobal';
import Overview from './components/LeftMenu/Overview';
import PresetMenu from './components/LeftMenu/PresetMenu';
import NameInput from './components/LeftMenu/NameInput';
import ToolButton from './components/LeftMenu/ToolButton';

interface ILeftMenu {
    mainWin: React.RefObject<any>;
    dataTree: any;
    dataTrendsTree: any;
    selectedElem: any;
}

export let pinnedLeftMenu: boolean = false;

const LeftMenu = (props: ILeftMenu) => {
    const { mainWin, dataTree, dataTrendsTree } = props;

    const [svgLeft, setSvgLeft] = React.useState('');

    const [isVisible, setIsVisible] = React.useState(true);

    React.useEffect(() => {
        fetch('/ixyber/vision/dcs/centumvp/centumvp_left_main.svg')
            .then((response) => response.text())
            .then((svg) => setSvgLeft(svg));
    }, []);

    const [pathFill1, setPathFill1] = React.useState('#5f94d4');
    const [pathFill2, setPathFill2] = React.useState('#5f94d4');
    const [pathFill3, setPathFill3] = React.useState('#5f94d4');

    const handleNeedleButton = () => {
        setIsVisible(false);
        setPathFill2('#5f94d4');
        pinnedLeftMenu = true;

        var mainWindow = document.querySelector('.centumvp-window');
        if (mainWindow instanceof HTMLElement) {
            mainWindow.style.paddingLeft = '380px';
        }

        var submitButton = document.querySelector(".centumvp_left_panel_main_inputs input[type='submit']");
        if (submitButton) {
            submitButton.setAttribute('onclick', 'CentumVP.set_name_input(this.value);');
        }
    };

    const handleCloseLeftMenu = () => {
        setIsVisible(true);
        pinnedLeftMenu = false;
    };

    //рендер левого меню
    React.useEffect(() => {
        document.addEventListener('RenderLeftMenu', handleRendered);

        return () => {
            document.removeEventListener('RenderLeftMenu', handleRendered);
        };
    }, []);

    const [MenuName, setMenuName] = React.useState<string>('');

    const handleRendered = (event: any) => {
        setMenuName(event.detail.name);
    };

    const [selectedElem, setSelectedElem] = React.useState('');

    const callbackSelectedElem = (selectedElem: string) => {
        setSelectedElem(selectedElem);
    };

    return (
        <div className="centumvp_left">
            <div className="centumvp_left_menu_main" dangerouslySetInnerHTML={{ __html: svgLeft }} />

            <div className={`centumvp_left_menu`}>
                <div className="centumvp_left_panel_top">
                    <svg width="100%" height="100%">
                        <g
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ display: 'inline', opacity: 1 }}
                            transform="translate(-36,-91.671631)">
                            <g
                                onClick={() => {
                                    window.CentumVP.close_left_menu();
                                    handleCloseLeftMenu();
                                }}>
                                <rect
                                    fill="#a7c7e0"
                                    onMouseOver={() => setPathFill1('#ffffff')}
                                    onMouseOut={() => setPathFill1('#5f94d4')}
                                    width="30"
                                    height="30"
                                    y="93"
                                    x="333"
                                />
                                <path
                                    onClick={() => {
                                        window.CentumVP.close_left_menu();
                                    }}
                                    onMouseOver={() => setPathFill1('#ffffff')}
                                    onMouseOut={() => setPathFill1('#5f94d4')}
                                    style={{
                                        opacity: 1,
                                        fill: pathFill1,
                                        fillOpacity: 0,
                                        fillRule: 'evenodd',
                                        stroke: pathFill1,
                                        strokeWidth: 3,
                                        strokeOpacity: 1
                                    }}
                                    d="m 355.01544,115.30082 -13.14756,-7.22842 13.1208,-7.57531"
                                />
                            </g>
                            {isVisible && (
                                <g
                                    onClick={() => {
                                        handleNeedleButton();
                                    }}>
                                    <rect
                                        fill="#a7c7e0"
                                        onMouseOver={() => setPathFill2('#ffffff')}
                                        onMouseOut={() => setPathFill2('#5f94d4')}
                                        width="30"
                                        height="30"
                                        y="93"
                                        x="302"
                                    />
                                    <path
                                        style={{ fill: pathFill2, fillOpacity: 1, fillRule: 'evenodd', stroke: 'none' }}
                                        d="m 315.56053,101.06098 c -2.60609,0 -4.71875,3.00809 -4.71875,6.71875 0,3.71066 2.11266,6.71875 4.71875,6.71875 1.33495,0 2.54788,-0.79379 3.40625,-2.0625 -0.33531,0.13102 -0.69483,0.21875 -1.0625,0.21875 -2.04818,0 -3.6875,-2.18181 -3.6875,-4.875 0,-2.69319 1.63932,-4.875 3.6875,-4.875 0.36767,0 0.72719,0.0877 1.0625,0.21875 -0.85837,-1.26871 -2.0713,-2.0625 -3.40625,-2.0625 z m 8.375,1.25 c -2.19188,0 -3.96875,2.44844 -3.96875,5.46875 0,3.02031 1.77687,5.46875 3.96875,5.46875 2.19188,0 3.96875,-2.44844 3.96875,-5.46875 0,-3.02031 -1.77687,-5.46875 -3.96875,-5.46875 z m -5.78125,2.59375 c -1.396,0 -2.5,1.29481 -2.5,2.875 0,1.58017 1.104,2.875 2.5,2.875 0.31291,0 0.62968,-0.10106 0.90625,-0.21875 -0.24104,-0.77739 -0.28645,-1.76698 -0.28125,-2.65625 0.006,-0.9927 0.0326,-1.81492 0.34375,-2.625 -0.29503,-0.13661 -0.63027,-0.25 -0.96875,-0.25 z m -8.1875,1.78125 -4.9375,1.125 4.9375,1.0625 0,-2.1875 z"
                                        onMouseOver={() => setPathFill2('#ffffff')}
                                        onMouseOut={() => setPathFill2('#5f94d4')}
                                    />
                                </g>
                            )}
                            <g>
                                <rect
                                    fill="#a7c7e0"
                                    onMouseOver={() => setPathFill3('#ffffff')}
                                    onMouseOut={() => setPathFill3('#5f94d4')}
                                    width="30"
                                    height="30"
                                    y="93"
                                    x="38"
                                />
                                <path
                                    style={{ fill: pathFill3, fillOpacity: 1, fillRule: 'evenodd', stroke: 'none' }}
                                    d="m 59.125,98.25 0,3.28125 C 57.450056,99.894569 55.185621,98.875 52.6875,98.875 c -5.143152,0 -9.3125,4.25329 -9.3125,9.5 0,5.24671 4.169348,9.5 9.3125,9.5 2.728686,0 3.296746,-0.0924 5,-2 -0.199534,-1.8926 -1.347928,-1.88748 -2.875,-1.125 -0.646714,0.22956 -1.34092,0.375 -2.0625,0.375 -3.521167,0 -6.375,-2.96611 -6.375,-6.625 0,-3.65889 2.853833,-6.625 6.375,-6.625 1.723042,0 3.263422,0.72179 4.40625,1.875 l -3.53125,0 0,2.75 8.25,0 0,-2.75 0,-5.5 -2.75,0 z"
                                    onMouseOver={() => setPathFill3('#ffffff')}
                                    onMouseOut={() => setPathFill3('#5f94d4')}
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="centumvp_left_panel_main">
                    <Overview
                        dataTree={dataTree}
                        dataTrendsTree={dataTrendsTree}
                        selectedElem={selectedElem}
                        callbackSelectedElem={callbackSelectedElem}
                        style={MenuName === 'Overview' ? { display: 'inline' } : { display: 'none' }}
                    />
                    <PresetMenu style={MenuName === 'Preset Menu' ? { display: 'inline' } : { display: 'none' }} />
                    <NameInput style={MenuName === 'Name Input' ? { display: 'inline' } : { display: 'none' }} />
                    <ToolButton
                        dataTree={dataTree}
                        SelectedElem={props.selectedElem}
                        callbackSelectedElem={callbackSelectedElem}
                        style={MenuName === 'Tool Button' ? { display: 'inline' } : { display: 'none' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default LeftMenu;
